<template>
    <b-modal
        v-model="modal"
        :title="$t('auth.two_factor_authentication')"
        title-class="text-grey font-weight-600"
        body-class="px-3s pt-0 pb-4s"
        modal-class="modal-confirm-enable-two-fa"
        hide-footer
        centered
    >
        <div class="text-center pt-3s mb-4s">
            <div class="mb-3s">
                <img
                    src="@/assets/images/auth/2-fa-enabled.svg"
                    alt="enabled"
                    class="w-100-px"
                />
            </div>
            <div class="text-semi-xl font-weight-600 mb-2">
                {{ $t('auth.enable_two_factor_confirm_title') }}
            </div>
            <div
                class="
                    modal-confirm-enable-two-fa__content
                    max-w-300-px
                    text-md text-grey
                    mx-auto
                "
            >
                {{ $t('auth.enable_two_factor_confirm_content') }}
            </div>
        </div>
        <div class="d-flex">
            <b-button
                variant="cinnabar"
                block
                size="lg"
                class="font-weight-600 text-white rounded-xl h-48-px mr-2"
                @click="confirmEnableTwoFA(true)"
            >
                {{ $t('button.yes') }}
            </b-button>
            <b-button
                variant="outline-cinnabar"
                block
                size="lg"
                class="font-weight-600 rounded-xl h-48-px ml-2 mt-0"
                @click="confirmEnableTwoFA(false)"
            >
                {{ $t('button.no_later') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ModalConfirmEnableTwoFA',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        confirmEnableTwoFA(value) {
            this.$emit('onConfirm', value);
            this.modal = false;
        },
    },
};
</script>
